<template >
<div class="container-fluid" v-if="lesson!=null&&lesson.deleted==false">
   <div class="row">
     <div class="col-md-8 col-sm-12">
      <div class="text-center">
        <ul>
          <li v-bind:class="tab_selected?'bottom-bordered':''" @click="$router.push({name:'StudentAssignment', params: {schoolId:schoolId, lessonId: lesson.id}})"><a href="#home"><h5 >Даалгавар</h5></a></li>
          <li @click="$router.push({name:'StudentLog', params: {schoolId:schoolId, lessonId: lesson.id}})"><a href="#home"><h5>Ирц</h5></a></li>
          <li @click="$router.push({name:'StudentScores', params: {schoolId:schoolId, lessonId: lesson.id}})"><a href="#home"><h5>Явцын дүн</h5></a></li>
        </ul>
      </div>
    <hr/>
      <div v-if="school && school.university==true">
        <h4 class="p-3 text-center">Сэдвүүд</h4>
        <public-topics v-if="topics && topics.length>0" :_editTopic="_editTopic" :topics="topics" :lesson="lesson" :schoolId="schoolId" :types="types" :lessonId="lesson.id"></public-topics>
        <div v-else class="alert alert-warning text-center mb-4"><h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4></div>

      </div>
      <div v-else>
        <div class="card">
          <public-topics v-if="topics && topics.length>0" :_editTopic="_editTopic" :topics="topics" :lesson="lesson" :schoolId="schoolId" :types="types" :lessonId="lesson.id"></public-topics>  
          <div v-else class="alert alert-warning text-center mb-4"><h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4></div>
        </div>
      </div>
      <hr class="mb-5"/>
     </div>
     <div class="col-md-4 col-sm-12">
       <lesson-info :lesson="lesson" :schoolId="schoolId" :edit="false" :showDetail="true"></lesson-info>
     </div>
   </div>

</div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'
import VueQrcode from 'vue-qrcode'
import PublicTopics from './PublicTopics';
import LessonInfo from '../school/shared/LessonInfo';
export default {
    name: "LessonDetailPublic",

    data() {
        return {
          tab_selected: true,
            lesson: null,
            topic:{
              'name':null,
              'description':null,
              'price':0,
              'tags':[],
              'shortname':null
            },
            topics:[],
            types:[],
            selectedType:null,
            studentsText:'',
            selectedTopic:null,
            tmpStudents:[],
            tmpAdditionalFile:{
              'name':'',
              'uploading':false,
              'uploadPercent':null
              
            },
            lessonBucket:'lessonFiles/',
            topicBucket:'lessonTopicFiles/',
            tagText:null,
            school:null,
        };
    },
    methods: {
        
      _getQA(){
          fb.db.collection("ContentTypes").get().then(querySnapshot=> {
              this.types=[]
              querySnapshot.forEach(doc=> {
                let object=doc.data()
                object.id = doc.id
                object.content=[]
                this.types.push(object);
              });
            
          });

          fb.db.collection('schools').doc(this.schoolId).get().then(schoolDoc=>{
            if(schoolDoc.exists){
              let school=schoolDoc.data();
              school.id=schoolDoc.id;
              this.school=school;

              fb.db.collection('schools/'+this.schoolId+"/lessons").doc(this.lessonId).onSnapshot(doc=> {
                  let lesson=doc.data();
                  lesson.id=doc.id;
                  this.lesson=lesson;
                
              });
              if(school && school.university && school.university==true){
                fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).collection("topics").orderBy("createdAt","desc").onSnapshot(querySnapshot=> {
                  this.topics=[]
                  querySnapshot.forEach(doc=> {
                    let object=doc.data()
                    object.id = doc.id;
                    object.details=[];
                    if(!object.published)
                      object.published=null;
                    doc.ref.collection("details").orderBy("createdAt").onSnapshot(contentSnapshot=> {
                      object.details=[];
                      contentSnapshot.forEach(contentDoc=> {
                        let content=contentDoc.data()
                        content.id = contentDoc.id;
                        content.uploading=false
                        content.uploadPercent=0
                        object.details.push(content);
                      });
                      
                    });
                    this.topics.push(object);
                  });
                  
                });
              }
              else{
                
                fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).collection("topics").orderBy("createdAt","desc").onSnapshot(querySnapshot=> {
                      this.topics=[];
                      querySnapshot.forEach(doc=> {
                        let object=doc.data()
                        object.id = doc.id;
                        object.details=[];
                        doc.ref.collection("details").orderBy("createdAt").onSnapshot(contentSnapshot=> {
                          object.details=[];
                          contentSnapshot.forEach(contentDoc=> {
                            let content=contentDoc.data()
                            content.id = contentDoc.id;
                            content.uploading=false
                            content.uploadPercent=0
                            object.details.push(content);
                          });
                          
                        });
                        this.topics.push(object);
                      });
                      
                    });
              }
            }
          });
          

      },
      
      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
      validFile(file){
        if(file.fileName.endsWith("mp4") 
            || file.fileName.endsWith("MP4") 
            || file.fileName.endsWith("MPEG") 
            || file.fileName.endsWith("mov") || file.fileName.endsWith("MOV")
            || file.fileName.endsWith("webm") || file.fileName.endsWith("WEBM")
          ){
            return false;
        }
        return true;
      },
      getYoutubeId(url) {
          const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
          const match = url.match(regExp);

          return (match && match[2].length === 11)
            ? match[2]
            : null;
      },
      getYoutubeIframe(url){
        if(url!=null && url!='' && url.toLowerCase().indexOf("youtube") != -1){
          var id= this.getYoutubeId(url);
          return 'https://www.youtube.com/embed/' + id ;
        }
        return null;
      },
      
      getType(type){
        if(type=="test")
          return "Тест";
        else if(type=="video")
          return "Видео хичээл";
        else if(type=="lecture")
          return "Лекц";
        else if(type=="seminar")
          return "Семинар";
        else if(type=="exam")
          return "Шалгалт";
        else if(type=="homework")
          return "Гэрийн даалгавар";
        else if(type=="coursework")
          return "Бие даалт";
        
      },
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    components: {
      VueQrcode,
      PublicTopics,
      LessonInfo
    },
    props: {
        lessonId: { 
            required: true,
        },
        schoolId:{
          required:true
        },
        sts:{
          required:false
        }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>
<style scoped>

</style>
